import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
// TODO implement own picker to provide all functionality defined in form
//import Picker from '../components/Picker'
import SelectedPage from './SelectedPage'
import Header from './Header'
import Footer from './Footer'
import { fetchForm } from '../actions'

class Survey extends Component {

  constructor(props) {
    super(props);
    this.formSelected(props.params.id);
  }

  formSelected = (formId) => {
    this.props.dispatch(fetchForm(formId))
  }

  render() {
    return (
      <div className="main-container">
        <div id="wrap">
          <Header fetching={this.props.form.isFetching} activepage="survey"/>
          <div className="container center-container">
            <div className="center-row">
              <div className="col-xs-12">
                <SelectedPage formId={this.props.params.id}/>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )
  }
}


Survey.propTypes = {}

function mapStateToProps(state) {
    const { user, form } = state;
    return {
        user: user.user,
        form,
    }
}

export default connect(mapStateToProps)(Survey)


// WEBPACK FOOTER //
// ./src/containers/Survey.js